/**
 * Fabrik Shared JavaScript
 *
 * Receives an already-configured Alpine instance from the client and registers
 * shared stores and async components. No bare npm imports here — fabrik files
 * live at /var/www/fabrik/ in the container, which can't resolve the client's
 * node_modules.
 */

export function setupFabrik(Alpine) {
  // Global stores (shared across all fabrik sites)
  Alpine.store("menuOpen", false);
  Alpine.store("searchOpen", false);
  Alpine.store("headerReduced", false);

  // Shared async components (fb- prefix avoids client-specific collisions)
  Alpine.asyncData("fbContactForm", () => import("./components/contact-form.js"));
  Alpine.asyncData("fbSlider", () => import("./components/slider.js"));
  Alpine.asyncData("fbArticleFilter", () => import("./components/article-filter.js"));
  Alpine.asyncData("fbFilterTabs", () => import("./components/filter-tabs.js"));
  // Alpine.asyncData("fbAccordion", () => import("./components/accordion.js"));
}
